<template>
    <!-- <div class="container">
        <div class="tabs no_print">
            <div class="item" :class="{ 'active' : current == 0 } " @click="current = 0">销售汇总(销售单)</div>
            <div class="item" :class="{ 'active' : current == 1 } " @click="current = 1">销售汇总(客户)</div>
            <div class="item" :class="{ 'active' : current == 2 } " @click="current = 2">销售汇总(销售员)</div>
            <div class="item" :class="{ 'active' : current == 3 } " @click="current = 3">销售汇总(品名)</div>
            <div class="item" :class="{ 'active' : current == 4 } " @click="current = 4">销售汇总(合同号)</div>
        </div>
        <div class="tab_content">
            <Summary ref="sale_repert_content_0" v-show="current == 0"></Summary>
            <Customer ref="sale_repert_content_1" v-show="current == 1"></Customer>
            <sale-man ref="sale_repert_content_2" v-show="current == 2"></sale-man>
            <Goods ref="sale_repert_content_3" v-show="current == 3"></Goods>
            <Contract ref="sale_repert_content_4" v-show="current == 4"></Contract>
        </div>
    </div> -->
    <div class="templete_box">
        <div class="crumbsNav clearfix no_print">
            <div class="navSon" :class="{ 'navSonChecked' : current == 0 } " @click="current = 0">销售汇总(销售单)</div>
            <div class="navSon" :class="{ 'navSonChecked' : current == 1 } " @click="current = 1">销售汇总(客户)</div>
            <div class="navSon" :class="{ 'navSonChecked' : current == 2 } " @click="current = 2">销售汇总(销售员)</div>
            <div class="navSon" :class="{ 'navSonChecked' : current == 3 } " @click="current = 3">销售汇总(品名)</div>
            <div class="navSon" :class="{ 'navSonChecked' : current == 4 } " @click="current = 4">销售汇总(合同号)</div>
        </div>
        <div class="templete">
            <Summary ref="sale_repert_content_0" v-show="current == 0"></Summary>
            <Customer ref="sale_repert_content_1" v-show="current == 1"></Customer>
            <sale-man ref="sale_repert_content_2" v-show="current == 2"></sale-man>
            <Goods ref="sale_repert_content_3" v-show="current == 3"></Goods>
            <Contract ref="sale_repert_content_4" v-show="current == 4"></Contract>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
        .tabs{
            display: flex; align-items: center; margin-bottom: 23px;
            .item {
                font-size:16px; font-weight:bold; color: #333333; cursor: pointer; border-bottom: 2px solid transparent; padding-bottom: 5px;
                &.active{ border-bottom: 2px solid #B21111; color: #b21111; }
            }
            .item + .item{ margin-left: 30px; }
        }
        .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
    }
</style>
<script>
    import Summary from '../../../components/sale/report/summary.vue'
    import Customer from '../../../components/sale/report/customer.vue'
    import SaleMan from '../../../components/sale/report/saleman.vue'
    import Goods from '../../../components/sale/report/goods.vue'
    import Contract from '../../../components/sale/report/contract.vue'
    export default {
        components:{
            Summary,
            Customer,
            SaleMan,
            Goods,
            Contract
        },
        data(){
            return{
                current : 0,
            }
        },
        created() {

        },
        mounted() {
            this.$refs[`sale_repert_content_0`].getList();
        },
        methods:{
            getPage(obj){
                this.current_page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            current(val){
                this.$refs[`sale_repert_content_${val}`].search();
            }
        }
    }
</script>
